import { combineReducers } from 'redux';
import skillNode from './skillNode';

export default combineReducers({
    skillNode
});